<div class="enrollment-windows">
  <table
    *ngIf="enrollmentWindowYears"
    class="enrollment-table table-striped borderless"
    cellspacing="0"
    border="0"
  >
    <thead>
      <tr>
        <th class="enrollment-windows-th"></th>
        <th class="enrollment-windows-th">Start Date</th>
        <th class="enrollment-windows-th">End Date</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let enrollmentYear of enrollmentWindowYears">
        <td class="enrollment-windows-td enrollment-year">
          {{ enrollmentYear }}
        </td>
        <td class="enrollment-windows-td">
          <input
            type="date"
            class="form-control date-input"
            required="true"
            [(ngModel)]="
              jobStatusService.updatedCustomerConfig[
                'enrollment.' + enrollmentYear + '.EnrollmentWindowStartDate'
              ]
            "
            (ngModelChange)="
              dateChanged($event, enrollmentYear, 'EnrollmentWindowStartDate')
            "
          />
          <p
            class="invalid-input-text"
            *ngIf="showError(enrollmentYear, 'EnrollmentWindowStartDate')"
          >
            Please specify a date for each enrollment window!
          </p>
        </td>
        <td class="enrollment-windows-td">
          <input
            type="date"
            class="form-control date-input"
            required="true"
            [(ngModel)]="
              jobStatusService.updatedCustomerConfig[
                'enrollment.' + enrollmentYear + '.EnrollmentWindowEndDate'
              ]
            "
            (ngModelChange)="
              dateChanged($event, enrollmentYear, 'EnrollmentWindowEndDate')
            "
          />
          <p
            class="invalid-input-text"
            *ngIf="showError(enrollmentYear, 'EnrollmentWindowEndDate')"
          >
            Please specify a date for each enrollment window!
          </p>
        </td>
      </tr>
    </tbody>
  </table>
</div>
